import React from 'react';
import {
  FavoriteRounded,
  FavoriteBorderRounded,
  PlayArrowRounded,
  PauseRounded,
} from '@mui/icons-material';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import defaultAvatar from '@src/assets/avatars/avatar-ai-voice.png';
import { StyledVoiceItem } from './index.style';

const VoiceItem = ({ voice, isPlaying, isFavourite, onPlay, onFavourite }) => {
  const PlayIcon = isPlaying ? PauseRounded : PlayArrowRounded;
  const FavouriteIcon = isFavourite ? FavoriteRounded : FavoriteBorderRounded;

  return (
    <StyledVoiceItem
      active={isPlaying}
      favourite={isFavourite}
      onClick={onPlay}
    >
      <img
        src={voice.avatar || voice.image || voice.roundImage || defaultAvatar}
        alt=""
        className="voice-avatar"
      />
      <div className="voice-info">
        <Typography
          className="voice-name"
          variant="body-16-semibold"
          color={COLOR.label2[100]}
        >
          {voice.name}
        </Typography>
      </div>
      <button
        type="button"
        className="voice-action voice-favourite"
        onClick={(e) => {
          // The card itself toggles playback, so the heart must not bubble.
          e.stopPropagation();
          onFavourite();
        }}
      >
        <FavouriteIcon className="voice-favourite-icon" />
      </button>
      <div className="voice-action voice-play">
        <PlayIcon className="voice-play-icon" />
      </div>
    </StyledVoiceItem>
  );
};

export default VoiceItem;
